export default __webpack_public_path__ + "click-button-fc2a1aa7d6d38803f5966552a52bed67.mp3";